export default __webpack_public_path__ + "static/media/modules_light.0f2f2ef6.png";